import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Collapse, Row, Spinner} from "reactstrap";
import {GenericButton} from "../../../../components/buttons/customButtons";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../../redux/selectors";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {TT_ADD, TT_DISH_DRINK, TT_EDIT, TT_REMOVE} from "../../../../components/i18n/toolTips";
import {ADD_STATE, REMOVE_STATE, setApp, setCategory, setItem} from "../../../../redux/actions/generics/IndexedActions";
import {aybMenuService} from "../../../../jwt/_services/ayb/aybMenuService";
import {DragDropList} from "../../../../components/draggableList/DragDropList";
import {MenuSectionForm} from "./_form";
import SausersSection from "../SausersSection/SausersSection";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {confirmAlert} from "react-confirm-alert";
import {ConfirmPriceExchange} from "../../../../components/confirmAlertForms/ConfirmPriceExchange";
import {dishDrinkPriceService} from "../../../../jwt/_services/ayb/dishDrinkPriceService";
import Separator from "../../../../components/Separator";

const MenuSection = (props) => {
    const path = props.path + '/menu';

    const parentComponentState = useSelector(state => getStateByPath(state, props.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const {app, category, udn, domainObject} = parentComponentState?.data || {};
    const {listDomainObjects} = componentState?.data || [];
    const {loading} = componentState?.data || false;

    const [sectionMode, setSectionMode] = useState('regular');
    const [menuItems, setMenuItems] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [isEditingSausers, setIsEditingSausers] = useState(false);

    const [showMenuModal, setShowMenuModal] = useState(true);
    const menuModalRef = useRef(null)


    const [cleaningPrices, setCleaningPrices] = useState(false);


    const showMenuForm = (item, index) => {
        setShowMenuModal(true);
        menuModalRef.current.showModal(item, index, category);
    }

    useEffect(() => {
        props.ADD_STATE(path);
        props.setApp(path, app);
        props.setCategory(path, category);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (!path)
            return;

        props.setApp(path, app);
        props.setCategory(path, category);
    }, [path]);

    useEffect(() => {
        const dataRequest = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item :  {
                place : { id : domainObject.id },
                udn : { id : udn.id }
            }
        }

        genericIndexedActions.search(path, aybMenuService, 0, 1000, dataRequest)
    }, []);

    useEffect(() => {
        if (!componentState?.data?.listDomainObjects || componentState?.data?.listDomainObjects.length === 0) return;

        // Crear una copia de listDomainObjects para evitar mutaciones directas y ordenarlos por showOrder
        setMenuItems(componentState?.data?.listDomainObjects.sort((a, b) => a.showOrder - b.showOrder).map((item, index) => {
            return {...item, isOpen: false}
        }));
    }, [componentState?.data?.listDomainObjects]);

    const onAddMenu = (index) => {
        showMenuForm(null, index);
    }
    const onEditMenu = (item, index) => {
        setItem(path, item)
        showMenuForm(item, index);
    }

    const onEditMenuSausers = (item, index) => {
        // set isOpen on index item
        let updatedMenuItems = [...menuItems];
        updatedMenuItems[index].isOpen = !updatedMenuItems[index].isOpen;
        setMenuItems(updatedMenuItems);

        // Alterna el estado isEditingSausers
        setSelectedIndex(index);
        setIsEditingSausers(!isEditingSausers);
        props.setItem(path, item);
    }

    const notImplemented = () => {
        console.log('Not implemented')
    }

    const onUpdateMenuCategories = (id, dataRequest) => {
        genericIndexedActions.update(path, aybMenuService, id, dataRequest)
    }

    const onReorderMenus = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let anyId = '' // Variable para guardar el id de cualquier ítem que haya cambiado de orden, necesitamos al menos un id real
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            if (reorderedItem.id) {
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    anyId = domainObject.id
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, aybMenuService, dataRequest)
    }

    const renderMenu = (item, index) => {
        return (
            <div className={'menu-item' + (item.isOpen ? '-open' : '') + (item.status ? '' : ' innactive' )}>
                <div className={'menu-item-header'}>
                    <h4 className="mb-0 text-truncate">
                        {item.title}
                    </h4>
                    <div className="toolbar">
                        {
                            item.isOpen ? <>
                                <GenericButton
                                    style={'warning-secondary'}
                                    label={'Limpiar Precios'}
                                    toolTip={'Eliminar los precios asignados desde Firebase'}
                                    icon={'fa-sync'}
                                    permission={'edit'}
                                    loading={cleaningPrices}
                                    disabled={cleaningPrices}
                                    onClick={_ => confirmCleanPrices(item)}/>
                                <Separator/>
                                <GenericButton
                                    style={'table'}
                                    label={'Volver a menus'}
                                    toolTip={'Regresar a menus'}
                                    icon={'fa-arrow-left'}
                                    permission={'search'}
                                    onClick={_ => onEditMenuSausers(item, index)}/>
                                </>
                                 :
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_DISH_DRINK}
                                    icon={'fa-coffee'}
                                    permission={'edit'}
                                    onClick={_ => onEditMenuSausers(item, index)}
                                />
                        }
                        {
                            !item.isOpen && <>
                                <GenericButton
                                    style={'table'}
                                    toolTip={TT_EDIT}
                                    icon={'fa-pen'}
                                    permission={'edit'}
                                    onClick={_ => {
                                        onEditMenu(item, index)
                                    }}
                                />
                                <TranslateButton path={path} item={item} service={aybMenuService} askForConfirmation={false} />
                                <GenericButton
                                    style={'danger-secondary'}
                                    toolTip={TT_REMOVE}
                                    icon={'fa-times'}
                                    permission={'remove'}
                                    onClick={notImplemented}
                                />
                            </>
                        }
                    </div>
                </div>
                <div className={'sauser-container'}>
                    <Collapse isOpen={item.isOpen || false}>
                        { item.isOpen && <SausersSection path={path} showHeader={false} onUpdateMenuCategories={onUpdateMenuCategories}/> }
                    </Collapse>
                </div>
            </div>
        )
    }

    const confirmAssignPrice = _ => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside:true,
        customUI: ({onClose}) => <ConfirmPriceExchange udn={udn} category={category} fbDataBaseId={app?.fbDataBase?.id} onClose={onClose}/>
    });



    const confirmCleanPrices = menu => {
        setCleaningPrices(true);

        aybMenuService.cleanPrices(menu?.id, app?.fbDataBase?.id)
            .then(response => {
                console.log('Prices cleaned successfully:', response);
            })
            .catch(error => {
                console.error('Error cleaning prices:', error);
            })
            .finally(() => setCleaningPrices(false));
    }







    return (
        <>
            <div className={'generic-sortable-container'}>
                <div className={'generic-sortable-container-header'}>
                    <h2>{'Menus'}</h2>
                    <div className={'top-right-header'}>
                        <GenericButton
                            style={'warning-secondary'}
                            label={'Actualizar precios'}
                            toolTip={'Elige el tipo de cambio para actualizar los precios'}
                            icon={'fa-sync'}
                            permission={'edit'}
                            onClick={confirmAssignPrice}/>
                        <GenericButton
                            style={'table'}
                            label={'Agregar'}
                            toolTip={TT_ADD}
                            icon={'fa-plus'}
                            permission={'edit'}
                            onClick={_ => {
                                onAddMenu(menuItems.length + 1)
                            }}/>
                    </div>
                </div>
                <div className={'generic-sortable-container-list'}>
                    {
                        loading ? <Spinner animation="border"/> :
                            (isEditingSausers ?
                                renderMenu(menuItems[selectedIndex], selectedIndex) :
                                <DragDropList
                                    items={menuItems?.sort((a, b) => a.showOrder - b.showOrder)}
                                    renderContent={renderMenu}
                                    onReorder={onReorderMenus}
                                    orientationHV={'vertical-container'} // CSS class para orientar los elementos horizontalmente horizontal-container, vertical-container, ruby-text-container
                                />)
                    }
                </div>
            </div>
            {
                showMenuModal && <MenuSectionForm
                    path={path}
                    parent={domainObject}
                    udn={udn}
                    app={app}
                    category={category}

                    ref={menuModalRef}
                />
            }
        </>
    );
}

MenuSection.propTypes = {
    //parent: propTypes.object.isRequired,

};

const mapStateToProps = _ => ({})

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem,
    setApp,
    setCategory,
})

export default connect(mapStateToProps, mapActionsToProps)(MenuSection)